import { AppMenuDto, CrudAction, CrudActionDto } from './app.model';
import { ViewWeatherComponent } from './pages/port/view-weather/view-weather.component';
import { ViewLocationComponent } from './pages/vessel/view-location/view-location.component';
import { eIdentityRouteNames } from '@abp/ng.identity/config';
import { LedgerCodeComponent } from './pages/company/ledger-code/ledger-code.component';
import { TypeOfCallSopInputPrecedenceRuleDetailsComponent } from './pages/type-of-call/type-of-call-sop-input-precedence-rule/type-of-call-sop-input-precedence-rule-details/type-of-call-sop-input-precedence-rule-details.component';
import { TypeOfCallSopInputPrecedenceRuleComponent } from './pages/type-of-call/type-of-call-sop-input-precedence-rule/type-of-call-sop-input-precedence-rule.component';
import { TypeOfCallSopReportMappingComponent } from './pages/type-of-call/type-of-call-sop-report-mapping/type-of-call-sop-report-mapping.component';
import { TypeOfCallVesselStatusMappingComponent } from './pages/type-of-call/type-of-call-vessel-status-mapping/type-of-call-vessel-status-mapping.component';

export const masterMenus = [
  // sample
  {
    path: 'sample',
    module: 'pages',
    invisible: true,
    requiredPolicy: 'Masters.Countries',
    crudAction: {
      list: 'pages/sample',
      read: 'pages/sample',
      create: 'pages/sample',
      update: 'pages/sample',
    } as CrudActionDto,
  },

  // TemplateDownload
  {
    path: 'templatedownload',
    module: 'pages',
    invisible: true,
  },
  // WeatherReport
  {
    path: 'weatherreport',
    module: 'pages',
    invisible: true,
  },
  // InterfaceType
  {
    path: 'interface-type',
    iconClass: 'deployment-unit',
    requiredPolicy: 'Masters.InterfaceTypes',
  },
  // TypeOfCallGroups
  {
    path: 'type-of-call-group',
    iconClass: 'deployment-unit',
    requiredPolicy: 'Masters.TypeOfCallGroups',
  },
  // CustomerTypeMaster
  {
    path: 'customer-type-master',
    iconClass: 'deployment-unit',
    requiredPolicy: 'Masters.CustomerTypeMasters',
  },
  // Country
  {
    path: 'country',
    iconClass: 'flag',
    requiredPolicy: 'Masters.Countries',
    features: { picture: true },
  },
  // Currency
  {
    path: 'currency',
    iconClass: 'dollar',
    requiredPolicy: 'Masters.Currencies',
  },
  // Office
  {
    path: 'office',
    lookupFieldName: 'code',
    lookupFieldCode: 'name',
    features: { attachments: true, comments: true },
    columns: [
      'code',
      'name',
      'city',
      'currencyName',
      'keyContactPerson',
      'telePhone',
      'mobile',
      'active',
    ],
    customColumns: [
      { prop: 'logoUrl', name: 'logoUrl', type: 'file' },
      { prop: 'agencyAppLayout', name: 'agencyAppLayout', type: 'string' },
    ],
    iconClass: 'bank',
    children: [
      {
        columns: ['name', 'isDomestic', 'isDefault', 'active'],
        path: 'bank',
        requiredPolicy: 'Masters.Offices',
      },
    ],
    requiredPolicy: 'Masters.Offices',
  },
  // Port
  {
    path: 'port',
    iconClass: 'bank',
    features: { attachments: true },
    children: [
      { path: 'port-location', requiredPolicy: 'Masters.Ports', features: { attachments: true } },
      { path: 'port-zone', requiredPolicy: 'Masters.PortZones' },
      { path: 'port-pda-column', requiredPolicy: 'Masters.Ports' },
    ],
    tabs: [{ path: 'view-weather', component: ViewWeatherComponent }],
    requiredPolicy: 'Masters.Ports',
  },
  // Port and Office Mapping
  {
    path: 'portofficemaster',
    lookupFieldName: 'officeName',
    lookupFieldCode: 'portName',
    iconClass: 'one-to-one',
    requiredPolicy: 'AgencyPlatform.PortOfficeMasters',
    invisible: true,
  },
  // MainGroup
  {
    path: 'main-group',
    iconClass: 'partition',
    children: [
      {
        iconClass: 'group',
        path: 'sub-group',
        columns: [
          'code',
          'name',
          'addressLine1',
          'addressLine2',
          'city',
          'telePhone',
          'keyContactPerson',
          'active',
        ],
        staticFilter: 'isSubGroup eq false',
        name: 'Customers',
        parentPropRef: 'maingroupid',
        requiredPolicy: 'Masters.Customers',
        children: [{ path: 'contact', iconClass: 'contacts' }],
        autoGenerateField: 'code',
      },
      { path: 'contact', iconClass: 'contacts' },
    ],
    requiredPolicy: 'Masters.Customers',
    features: { attachments: true, comments: true, picture: true },
  },
  // Service
  {
    path: 'type-of-call',
    iconClass: 'appstore',
    requiredPolicy: 'Masters.TypeOfCalls',
    autoGenerateField: 'code',
    crudAction: {
      read: 'pages/type-of-call',
      create: 'pages/type-of-call',
      update: 'pages/type-of-call',
    },
    children: [],
    tabs: [
      {
        path: 'typeofcallsopinputprecedencerules',
        component: TypeOfCallSopInputPrecedenceRuleComponent,
        iconClass: 'sliders',
        requiredPolicy: 'Masters.TypeOfCallSopInputPrecedenceRules',
      },
      {
        path: 'typeofcallsopinputvesselstatusmapping',
        component: TypeOfCallVesselStatusMappingComponent,
        iconClass: 'environment',
        requiredPolicy: 'Masters.TypeOfCallSopInputVesselStatusMappings',
      },
      {
        path: 'typeofcallsopreportmapping',
        component: TypeOfCallSopReportMappingComponent,
        iconClass: 'account-book',
        requiredPolicy: 'Masters.TypeOfCallSopReportMappings',
      },
    ],
  },

  // Charge Item Section
  {
    path: 'charge-item-section',
    iconClass: 'group',
    requiredPolicy: 'Masters.ChargeItemSections',
    autoGenerateField: 'code',
  },
  // Boat Charge Item Section
  {
    path: 'boat-charge-item-section',
    iconClass: 'group',
    requiredPolicy: 'Masters.BoatChargeItemSections',
    autoGenerateField: 'code',
  },
  // chargeitem
  {
    path: 'charge-item',
    iconClass: 'ci',
    children: [
      {
        path: 'charge-item-ax-account',
        requiredPolicy: 'Masters.ChargeItems',
      },
    ],
    requiredPolicy: 'Masters.ChargeItems',
    autoGenerateField: 'code',
  },
  // Check List Item Section
  {
    path: 'checkList-item-section',
    invisible: true,
    iconClass: 'group',
    requiredPolicy: 'Masters.CheckListItemSections',
    crudAction: { list: 'x/pg/checkListItemSection' },
    autoGenerateField: 'code',
  },

  // TaskItems
  {
    path: 'task-item',
    iconClass: 'unordered-list',
    requiredPolicy: 'Masters.TaskItems',
    autoGenerateField: 'code',
    module: 'pages',
    crudAction: { list: 'pages/task-item' },
  },

  // AX Account Master
  {
    path: 'refaccountmaster',
    iconClass: 'book',
    children: [
      {
        path: 'chargeitemaccountmapping',
        requiredPolicy: 'AgencyPlatform.ChargeItemAccountMappings',
      },
    ],
    requiredPolicy: 'AgencyPlatform.RefAccountMasters',
    invisible: true,
  },
  // Customer
  {
    path: 'customer',
    iconClass: 'team',
    features: { attachments: true, comments: true, picture: true },
    requiredPolicy: 'Masters.Customers',
    crudAction: {
      list: 'pages/customer',
      read: 'pages/customer',
      create: 'pages/customer',
      update: 'pages/customer',
    } as CrudActionDto,
    children: [
      {
        iconClass: 'group',
        path: 'sub-group',
        name: 'Customers',
        parentPropRef: 'subgroupid',
        requiredPolicy: 'Masters.Customers',
        children: [{ path: 'contact', iconClass: 'contacts' }],
      },
    ],
    invisible: true,
    autoGenerateField: 'code',
  },
  // Designation
  {
    path: 'designation',
    requiredPolicy: 'Masters.Designations',
  },
  // EventItem
  {
    path: 'event-item',
    iconClass: 'calendar',
    requiredPolicy: 'Masters.EventItems',
  },
  // CargoType
  {
    path: 'cargo-type',
    iconClass: 'build',
    requiredPolicy: 'Masters.CargoTypes',
  },
  // BunkerType
  {
    path: 'bunker-type',
    iconClass: 'pic-right',
    requiredPolicy: 'Masters.BunkerTypes',
  },
  // EmailType
  {
    path: 'email-type',
    iconClass: 'mail',
    requiredPolicy: 'Masters.EmailTypes',
  },
  // Vessel
  {
    path: 'vessel',
    iconClass: 'crown',
    features: { attachments: true, comments: true, picture: true },
    columns: ['name', 'imoNumber', 'callSign', 'mmsi', 'vesselTypeName', 'active'],
    tabs: [
      { path: 'view-location', component: ViewLocationComponent, iconClass: 'aim' },
      // { path: 'vessel-contacts', component: VesselContactsComponent, iconClass: 'contacts' },
    ],
    children: [
      {
        // columns: ['name', 'isDomestic', 'isDefault', 'active'],
        path: 'vessel-contact',
        requiredPolicy: 'Masters.Vessels',
        iconClass: 'contacts',
      },
    ],
    requiredPolicy: 'Masters.Vessels',
    invisible: true,
    crudAction: { list: 'pages/vessel', create: 'pages/vessel', update: 'pages/vessel' },
  },
  // Vessel Type
  {
    path: 'vessel-type',
    iconClass: 'crown',
    requiredPolicy: 'Masters.VesselTypes',
  },
  // Email
  {
    path: 'contact',
    requiredPolicy: 'AgencyPlatform.Contacts',
    invisible: true,
  },
  // customertype
  {
    path: 'customertype',
    // requiredPolicy: 'AgencyPlatform.CustomerTypes',
    crudAction: {
      create: CrudAction.hidden,
    },
  },

  {
    path: 'unitofmeasure',
    iconClass: 'mail',
    requiredPolicy: 'Masters.UnitofMeasures',
  },

  // Users
  {
    path: 'userprofile',
    invisible: true,
    crudAction: {
      read: 'admin/users',
      create: 'admin/users',
    },
  },
  {
    path: 'identityuser',
  },
  {
    path: 'appuser',
    requiredPolicy: 'AbpIdentity.Users',
    invisible: true,
    crudAction: {
      list: 'admin/internalusers',
    },
  },

  // Vendor
  {
    path: 'vendor',
    iconClass: 'deployment-unit',
    features: { attachments: true, comments: true, picture: true },
    links: [{ path: 'invoice', requiredPolicy: 'Transactions.Invoices', iconClass: 'file-text' }],
    children: [
      {
        path: 'vendor-contact',
        requiredPolicy: 'Masters.Vendors',
        iconClass: 'contacts',
      },
      {
        path: 'vendor-charge-item-section-mapping',
        requiredPolicy: 'Masters.Vendors',
        iconClass: 'contacts',
      },
      {
        path: 'vendor-boat-charge-item-section-mapping',
        requiredPolicy: 'Masters.Vendors',
        iconClass: 'contacts',
      },
    ],
    requiredPolicy: 'Masters.Vendors',
    invisible: true,
    autoGenerateField: 'code',
    crudAction: {
      list: 'pages/vendor',
      read: 'pages/vendor',
    },
  },

  // Invoice
  {
    path: 'invoice',
    requiredPolicy: 'Masters.Invoices',
    lookupFieldName: 'invoiceNo',
    lookupFieldCode: 'details',
    invisible: true,
    crudAction: {
      read: 'vendor',
      create: CrudAction.hidden,
      update: CrudAction.hidden,
      delete: CrudAction.hidden,
    },
  },

  // vendorType
  {
    path: 'vendor-type',
    iconClass: 'deployment-unit',
    requiredPolicy: 'Masters.VendorTypes',
    // invisible: true,
  },

  // Templates
  {
    path: 'template',
  },

  // Static Templates
  {
    path: 'static-template',
    module: 'pages',
    iconClass: 'file-protect',
    requiredPolicy: 'Masters.Templates',
    crudAction: {
      list: 'pages/static-template',
      read: 'pages/static-template',
      update: 'pages/static-template',
      delete: CrudAction.hidden,
    },
  },

  // Sop Input
  {
    path: 'sop-input',
    iconClass: 'border-outer',
    lookupFieldName: 'title',
    requiredPolicy: 'Masters.SopInputs',
    crudAction: {
      read: 'pages/sop-input',
      create: 'pages/sop-input',
      update: 'pages/sop-input',
    },
  },

  {
    path: 'warehouse',
    parentName: 'Warehouse Masters',
    iconClass: 'shop',
    requiredPolicy: 'Masters.WarehouseMaster.Warehouses',
    columns: ['name', 'officeName', 'active'],
    /* crudAction: {
      read:   'pages/warehouse',
      create: 'pages/warehouse',    // ← add /create
      update: 'pages/warehouse',    // ← add /update
    }, */
  },

  {
    path: 'location',
    parentName: 'Warehouse Masters',
    iconClass: 'environment',
    requiredPolicy: 'Masters.WarehouseMaster.Location',
    columns: ['name', 'officeName', 'active'],
  },

  {
    path: 'shipment-type',
    parentName: 'Warehouse Masters',
    iconClass: 'profile',
    requiredPolicy: 'Masters.WarehouseMaster.ShipmentType',
    columns: ['name', 'active'],
  },

  {
    path: 'product-master',
    parentName: 'Warehouse Masters',
    iconClass: 'qrcode',
    requiredPolicy: 'Masters.WarehouseMaster.ProductMaster',
    columns: ['name', 'active'],
  },

  // SOP Templator
  {
    path: 'sop-report',
    module: 'pages',
    iconClass: 'file-sync',
    lookupFieldName: 'name',
    requiredPolicy: 'Masters.SopReports',
    crudAction: {
      list: 'pages/sop-report',
      read: 'pages/sop-report',
      create: 'pages/sop-report',
      update: 'pages/sop-report',
    },
  },

  // userGroup
  {
    path: 'user-group',
    iconClass: 'deployment-unit',
    requiredPolicy: 'Masters.UserGroups',
    invisible: true,
  },
  // quicklink
  {
    path: 'quick-link',
    requiredPolicy: 'Common.QuickLinks',
  },

  // entitycodeseq
  {
    path: 'entitycodeseq',
    name: 'EntityCodeSeq',
    invisible: true,
  },

  // Email
  {
    path: 'email',
    iconClass: 'mail',
  },
  {
    path: 'company',
    requiredPolicy: 'Masters.Companies',
    // links: [{ path: 'ledgerCode', requiredPolicy: 'Masters.Companies', iconClass: 'account-book' }],
    children: [
      {
        path: 'office',
        requiredPolicy: 'Masters.Offices',
        iconClass: 'bank',
      },
      {
        path: 'tax-group',
        requiredPolicy: 'Masters.TaxGroups',
        children: [
          {
            path: 'tax',
            requiredPolicy: 'Masters.Taxes',
          },
        ],
      },
      {
        path: 'company-setting',
        requiredPolicy: 'Masters.Companies',
        iconClass: 'setting',
      },
    ],
    tabs: [
      {
        path: 'ledgercode',
        component: LedgerCodeComponent,
        iconClass: 'account-book',
        requiredPolicy: 'Masters.Companies',
      },
    ],
  },
  {
    path: 'tenant-info',
    module: 'pages',
    requiredPolicy: 'Masters.TenantInfos',
    crudAction: {
      list: 'pages/tenant-info',
      read: 'pages/tenant-info',
      create: 'x/pg/tenant-info',
      update: 'x/pg/tenant-info',
    },
    features: {},
    tabs: [],
    customColumns: [
      { name: 'logoUrl', prop: 'logoUrl', type: 'string' },
      { name: 'hasMobile', prop: 'hasMobile', type: 'boolean' },
      { name: 'disableMobile', prop: 'disableMobile', type: 'boolean' },
      { name: 'loginContent', prop: 'loginContent', type: 'string' },
      { name: 'copyright', prop: 'copyright', type: 'string' },
      { name: 'aboutLink', prop: 'aboutLink', type: 'string' },
      { name: 'contactLink', prop: 'contactLink', type: 'string' },
      { name: 'inquiryLink', prop: 'inquiryLink', type: 'string' },
      { name: 'logoUrl2', prop: 'logoUrl2', type: 'string' },
      { name: 'disableDashboard', prop: 'disableDashboard', type: 'boolean' },
      { name: 'appName', prop: 'appName', type: 'string' },
    ],
  },
  // TaxGroup
  {
    path: 'tax-group',
    lookupFieldName: 'code',
    lookupFieldCode: 'name',
    iconClass: 'deployment-unit',
    children: [
      {
        columns: ['code', 'name', 'taxPercentage', 'active', 'isDefault'],
        path: 'tax',
        iconClass: 'dollar',
        requiredPolicy: 'Masters.Taxes',
      },
    ],
    requiredPolicy: 'Masters.TaxGroups',
    //autoGenerateField: 'code',
  },
] as AppMenuDto[];

export const adminMenu = [
  {
    path: 'roles',
    iconClass: 'apartment',
    name: eIdentityRouteNames.Roles,
    requiredPolicy: 'AbpIdentity.Roles',
  },
  {
    path: 'user-group',
    iconClass: 'deployment-unit',
    name: 'User Group',
    module: 'x/pg',
    requiredPolicy: 'Masters.UserGroups',
  },
  {
    path: 'users',
    iconClass: 'user',
    requiredPolicy: 'AbpIdentity.Users',
  },
  {
    path: 'externalusers',
    iconClass: 'user',
    name: 'External Users',
    requiredPolicy: 'AbpIdentity.Users',
  },
];
